// Usar as rotas do backend serverless (SalesBoxServeless.Api)
export const potentialAudienceExportBase = `potential-audience-export`;

export const postPotentialExportFile = `${potentialAudienceExportBase}/create-potential-file-export`;
export const deleteFileExportById = `${potentialAudienceExportBase}/delete-file-export`;
export const getAllDataFileExport = `${potentialAudienceExportBase}/get-file-export-potential`;
export const downloadExportFile = `${potentialAudienceExportBase}/download`;
export const exportToCRM = `webhook-test/aa11fbd5-ab07-4163-91b7-7fe2f6b9b7f1`;
